import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'app/store';

const budgetScenarioSaveModalSlice = createSlice({
  name: 'budgetScenarioSaveModal',
  initialState: {
    isOpen: false,
    budgetScenarioName: '',
    budgetId: ''
  },
  reducers: {
    openBudgetScenarioSaveModal: (
      state,
      { payload }: PayloadAction<{ budgetId: string; scenarioName: string }>
    ) => {
      state.isOpen = true;
      state.budgetId = payload.budgetId;
      state.budgetScenarioName = payload.scenarioName;
    },
    closeBudgetScenarioSaveModal: (state) => {
      state.isOpen = false;
      state.budgetScenarioName = '';
      state.budgetId = '';
    }
  }
});

export const { openBudgetScenarioSaveModal, closeBudgetScenarioSaveModal } =
  budgetScenarioSaveModalSlice.actions;

export const budgetScenarioSaveModalReducer =
  budgetScenarioSaveModalSlice.reducer;

export const selectBudgetScenarioSaveModalState = (state: RootState) =>
  state.budgetScenarioSaveModal;
